import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getHappycallQuestionList, saveHappycallResult } from "../store/api/HappycallAPI";
import HappycallItem from "../Components/Happycall/HappycallItem";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, Fragment, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Loader from "react-loader-spinner";
import QRCodeReader from "../Components/QRCode_Reader/QR_Reader";
import barCodeImg from "../content/images/barcodeReader.png";
import { getProductInfoBySerialOrCode, setPopupStatus } from '../store/api/GetAllProduct';
const Happycall = () => {
    const dispatch = useDispatch();
    const { serviceType, serviceID } = useParams();
    const [popQrCode, setPopQrCode] = useState({ show: false });
    const questionList = useSelector(state => state.happycallDataReducer.questionList);
    let isLoading = useSelector(state => state.loading?.isLoading);
    const openPopup = useSelector(state => state.popup?.openPopup);
    const { productDataQRCode } = useSelector(state => { return { productDataQRCode: state.customerDataReducer.productDataQRCode } });
    const { register, handleSubmit, errors } = useForm();
    useEffect(async () => {
        document.body.className = "notMain";
        dispatch(getHappycallQuestionList());
    }, []);
    useEffect(() => {

    }, [isLoading]);
    const history = useHistory();
    const onSubmit = (data) => {
        let results = [];
        Object.keys(data).map(key => key !== "ProductId" && key !== "ServiceType" ? results.push({ ID: key, Value: data[key] }) : "");
        data.ProductId = Number(data.ProductId);
        let dataToSend = {};
        dataToSend.ProductId = data.ProductId;
        dataToSend.ServiceType = data.ServiceType;
        dataToSend.ServiceID = serviceID;
        dataToSend.Results = results;
        dispatch(saveHappycallResult(dataToSend, () => {

            history.push("./");

        }));
    }
    function findProductByModel(data) {
        dispatch(getProductInfoBySerialOrCode(data.ProductSerial));
    }
    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle" > رضایت سنجی </div>
                <div className="card-body bodyStyle">
                    {isLoading && <Loader type="BallTriangle" color="red" height={50} width={50} />}
                    {!(Number(serviceID) > 0) && <button className="btn btn-default btn-block" type="button" onClick={() => setPopQrCode({ show: true })} style={{ padding: 0 }}><img src={barCodeImg} /></button>}
                    {popQrCode.show && window.innerWidth <= 414 && <QRCodeReader setProductData={findProductByModel} setPopupData={setPopQrCode} />}
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {productDataQRCode && productDataQRCode.ID &&
                            <Fragment>
                                <input type="hidden" className="form-control" name="ProductId" ref={register()} value={productDataQRCode.ID} />
                                <div className="form-group">
                                    <label> نام محصول </label>
                                    <input type="text" className="form-control" defaultValue={productDataQRCode.Name} />
                                </div>
                                <div className="form-group">
                                    <label> مدل محصول </label>
                                    <input type="text" className="form-control" defaultValue={productDataQRCode.Model} />
                                </div>
                                <div className="form-group">
                                    <label> شماره سریال </label>
                                    <input className="form-control" name="SerialNumber" type="text" defaultValue={productDataQRCode.SerialNumber} />
                                </div>
                            </Fragment>
                        }
                        {!isLoading &&
                            <Fragment>
                                <div className="form-group">
                                    <label> نوع سرویس </label>
                                    <select className="form-control" name="ServiceType" ref={register({ required: true })} defaultValue={serviceType}>
                                        <option value=""> لطفا انتخاب کنید </option>
                                        <option value="repair"> تعمیر </option>
                                        <option value="install"> نصب </option>
                                    </select>
                                    {errors.ServiceType && <small className="errors"> نوع را وارد کنید </small>}
                                </div>
                                <div> {questionList && questionList.map((item, i) => <HappycallItem item={item} register={register} key={i} />)} </div>
                                <button className="btn btn-success w-100 mt-2">ثبت دیدگاه</button>
                            </Fragment>
                        }
                    </form>
                </div>
            </div>
        </div>
    )

}
export default Happycall;